import { useState, useMemo } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';
import classes from './CustomMonthPicker.module.scss';
import { monthsWithIndex } from '../../../utils/constants';
import colors from '../../../scss/colors';

const CustomMonthPicker = ({
  dateDisablingAbility,
  month,
  daysAvailability = {
    months: [],
    years: []
  },
  year,
  setMonth,
  setYear,
  backgroundColor = colors.PAGE_BACKGROUND,
  disabledBeforeIncluded = { month: null, year: null },
  dateBackAction = () => {},
  dateForwardAction = () => {}
}) => {
  const { t } = useTranslation();
  const [yearToShow, setYearToShow] = useState(year);

  const monthsItems = monthsWithIndex(t);

  const isSelected = (monthIndex) => monthIndex === parseInt(month, 10) && year === yearToShow;

  const isDisabled = (monthIndex) =>
    monthIndex <= disabledBeforeIncluded.month && yearToShow <= disabledBeforeIncluded.year;

  const shortDayAvailability = daysAvailability.months.map((item) => item.substring(0, 3));
  const isMonthDisabled = (day) => dateDisablingAbility && !shortDayAvailability.includes(day);
  const sortedYearArray = daysAvailability.years.sort((a, b) => a - b);

  const isNextYearsDisabled = useMemo(
    () =>
      dateDisablingAbility &&
      !sortedYearArray.reduce(
        (acc, currentValue) => currentValue !== parseInt(yearToShow, 10),
        parseInt(yearToShow, 10)
      ),
    [yearToShow]
  );
  const isPreviousYearsDisabled = useMemo(
    () => dateDisablingAbility && !sortedYearArray.includes(parseInt(yearToShow, 10) - 1),
    [yearToShow]
  );

  const handlePreviousCalendar = () => {
    setYearToShow((dateBack) => {
      const date = parseInt(dateBack, 10) - 1;
      dateBackAction(`${date}-01-01`);
      return date;
    });
  };

  const handleNextCalendar = () => {
    setYearToShow((dateForward) => {
      const date = parseInt(dateForward, 10) + 1;
      dateForwardAction(`${date}-01-01`);
      return date;
    });
  };

  return (
    <div className={classes.mainWrapper} style={{ backgroundColor }}>
      <div className={classes.calendarHeaderWrapper}>
        <div className={classes.actionButtons}>
          {(!disabledBeforeIncluded.year || yearToShow > disabledBeforeIncluded.year) && (
            <ArrowBackIosNewIcon
              fontSize="small"
              onClick={handlePreviousCalendar}
              sx={{ visibility: isPreviousYearsDisabled ? 'hidden' : 'visible', color: colors.NAVY_BLUE }}
            />
          )}
          <p>{yearToShow}</p>
          <ArrowForwardIosIcon
            fontSize="small"
            onClick={handleNextCalendar}
            sx={{ visibility: isNextYearsDisabled ? 'hidden' : 'visible', color: colors.NAVY_BLUE }}
          />
        </div>
      </div>
      <div className={classes.monthsWrapper}>
        {monthsItems.map(({ key, value }) => (
          <button
            key={`month-${key}`}
            onClick={() => {
              if (isMonthDisabled(value)) return;
              if (!isDisabled(key)) {
                setMonth(key);
                setYear(yearToShow, key);
              }
            }}
            className={`${classes.calendarMonthCell} ${isSelected(key) ? classes.selected : ''} ${
              isDisabled(key) || isMonthDisabled(value) ? classes.disabled : ''
            }`}
          >
            {value}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomMonthPicker;
